import { type ToastOptions } from 'react-toastify';

export enum Color {
	BLACK = 'black',
	WHITE = 'white',

	GRAY_100 = 'gray100',
	GRAY_200 = 'gray200',
	GRAY_300 = 'gray300',
	GRAY_400 = 'gray400',
	GRAY_500 = 'gray500',
	GRAY_600 = 'gray600',

	BLUE_LIGHT = 'blue',

	RED_300 = 'red300',
	RED_100 = 'red100',

	LIME_200 = 'lime200',
	GREEN_200 = 'green200',
	GREEN_400 = 'green400',
	GREEN_700 = 'green700',
	GREEN_800 = 'green800',

	ORANGE_700 = 'orange700',
	ORANGE_300 = 'orange300',
	ESMERALD = 'esmerald',
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning',
	VARIANT_PERFIL = 'variant_profile',
}

export const toastConfig: ToastOptions = {
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
	theme: 'colored',
	style: { textAlign: 'left' },
	position: 'top-right',
	autoClose: 4000,
	hideProgressBar: true,
};

export const WORKER_STRING = 'Trabajador';
